module.exports = __webpack_public_path__ + "img/coverage.517b330d.svg";